import { Tabset } from "core/Controls/Tabset";
import { EventListener, mustBeHTMLElement } from "silver";

type TogglerData = {
	isDefault: boolean;
	uid: string;
	toggler?: HTMLElement;
	toggled: HTMLElement;
};

function getTogglerData(root: HTMLElement): TogglerData[] {
	return Array.from(root.querySelectorAll("[data-item-toggled-uid]") as NodeListOf<HTMLElement>)
		.map((toggled: HTMLElement): TogglerData => {
			const uid = toggled.dataset.itemToggledUid || "";
			const toggler = (root.querySelector(`[data-item-toggler-uid="${uid}"]`) as HTMLElement|null) || undefined;
			const isDefault = toggled.dataset.itemToggledDefault === "true";

			return { uid, toggled, toggler, isDefault };
		});
}

export class TogglerTabset {
	public readonly onTabChange = EventListener.create<{ tabId: string }>("tabActivate");
	private tabset: Tabset;
	private toggles: TogglerData[] = [];
	private defaultToggle?: TogglerData;

	constructor(root: HTMLElement) {
		this.tabset = new Tabset(root, mustBeHTMLElement(root.querySelector(`[role="tablist"]`)), root);
		this.tabset.onTabActivate((e) => {
			e.tab.tab.classList.add("active");
			e.tab.tabpanel.hidden = false;
			if (this.defaultToggle) {
				this.defaultToggle.toggled.hidden = true;
			}
			this.onTabChange.trigger({ tabId: e.tab.tabId });
		});
		this.tabset.onTabDeactivate((e) => {
			e.tab.tab.classList.remove("active");
			e.tab.tabpanel.hidden = true;
		});

		this.toggles = getTogglerData(root);
		let first: boolean = true;
		this.toggles.forEach(toggle => {
			if (toggle.toggler) {
				this.tabset.add({
					tabId:    toggle.uid,
					tab:      toggle.toggler,
					tabpanel: toggle.toggled
				});
				if (first) {
					this.tabset.showTab(toggle.uid);
					first = false;
				}
			} else if (toggle.isDefault) {
				this.defaultToggle = toggle;
			}
		});
	}
}
